/**
 * Descarga un Blob sin dependencias externas.
 */
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
};

/**
 * Abre el selector nativo para compartir un PDF. En navegadores sin soporte
 * para archivos compartidos, descarga el comprobante para que el usuario
 * pueda adjuntarlo manualmente.
 *
 * @returns {Promise<'shared'|'downloaded'|'cancelled'>}
 */
export const shareOrDownloadPdf = async ({
  blob,
  filename,
  title = 'Comprobante de venta',
}) => {
  const pdfBlob = blob instanceof Blob
    ? blob
    : new Blob([blob], { type: 'application/pdf' });
  const file = new File([pdfBlob], filename, { type: 'application/pdf' });
  const canShareFiles = navigator.share
    && (!navigator.canShare || navigator.canShare({ files: [file] }));

  if (canShareFiles) {
    try {
      await navigator.share({
        title,
        files: [file],
      });
      return 'shared';
    } catch (error) {
      if (error && error.name === 'AbortError') return 'cancelled';
      // Si el navegador anunció soporte pero falló, conserva una salida útil.
    }
  }

  downloadBlob(pdfBlob, filename);
  return 'downloaded';
};
